export default "__VITE_ASSET__Dw2yb9ZH__"